
import { Form } from 'element-ui';
import { Component, Vue } from 'vue-property-decorator';
import { getEncData } from '@/api/client/nice';
import { findPassword, findId } from '@/api/user';

@Component({
  name: 'LoginPage',
  components: {
  },
})

export default class extends Vue {
  mounted() {
    this.getEncData();
  }

  private encData: any = '';

  private commonApiUrl = process.env.VUE_APP_BASE_API;

  private apiUrl = process.env.VUE_APP_CLIENT_API;

  private loading = false;

  private form: any = {
    userId: '',
    actualName: '',
    concatNumber: '',
  }

  private type: any = this.$route.query.type;

  private validateUserId = (rule:any, value:any, callback:any) => {
    if (value === '') {
      callback(new Error('아이디를 입력하세요.'));
    }
  };

  private validateConcatNumber = (rule:any, value:any, callback:any) => {
    const regPhone = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;
    const regPhone2 = /^(0(2|3[1-3]|4[1-4]|5[1-5]|6[1-4]))-(\d{3,4})-(\d{4})$/;
    if (!regPhone.test(value) && !regPhone2.test(value)) {
      callback(new Error('연락처 형식에 맞지 않습니다.'));
    } else {
      callback();
    }
  };

  private rules = {
    userId: [
      { required: true, message: '아이디를 입력해주세요.', trigger: ['change', 'blur'] },
    ],
    actualName: [
      { required: true, message: '성명을 입력하세요.', trigger: ['change', 'blur'] },
    ],
    concatNumber: [
      { required: true, message: '연락처를 입력하세요.', trigger: ['change', 'blur'] },
    ],
  }

  private getEncData() {
    getEncData().then((res) => {
      this.encData = res.data;
    });
  }

  private handleConfirm(type: any) {
    console.log(type);
    (this.$refs.form as Form).validate((valid: boolean) => {
      if (valid) {
        this.loading = true;
        if (type === 'id') {
          findId(this.form).then((res) => {
            this.$alert(`해당 명의로 가입된 계정은 '${res.data}' 입니다.`, '아이디 정보', {
            }).then(() => {
              this.$router.push({ name: 'Login' });
            });
          }).catch((error: any) => {
            if (error.response.statusText === 'Not Found') {
              this.$message.warning('해당 계정 정보를 찾을 수 없습니다.');
            } else {
              this.$message.error('아이디 찾기에 실패했습니다. 관리자에게 문의해주세요.');
            }
            this.loading = false;
          });
        } else if (type === 'pw') {
          findPassword(this.form).then(() => {
            this.$message.success('입력하신 연락처에 임시패스워드를 발급했습니다. 로그인 후 패스워드를 수정해주세요.');
            this.$router.push({ name: 'Login' });
            this.loading = false;
          }).catch((error: any) => {
            if (error.response.statusText === 'Not Found') {
              this.$message.warning('해당 계정 정보를 찾을 수 없습니다.');
            } else {
              this.$message.error('임시패스워드 발급에 실패했습니다. 관리자에게 문의해주세요.');
            }
            this.loading = false;
          });
        }
      }
    });
  }

  private handleNicePopup() {
    const nicePopup = window.open('', 'popupChk', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no');
    (this.$refs.niceForm as HTMLFormElement).action = 'https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb';
    (this.$refs.niceForm as HTMLFormElement).target = 'popupChk';
    (this.$refs.niceForm as HTMLFormElement).submit();
    const loop = setInterval(() => {
      if (nicePopup && nicePopup.closed) {
        clearInterval(loop);
        if ((document.getElementById('actualName') as any).value && (document.getElementById('concatNumber') as any).value) {
          // this.form.actualName = (document.getElementById('actualName') as any).value;
          this.form.concatNumber = (document.getElementById('concatNumber') as any).value;
        }
      }
    }, 400);
  }

  private removeSpaceFormData() {
    this.form.userId = this.form.userId.replace(/(\s*)/g, '');
  }
}
